<template>
  <div>
    <p style="margin: 0 0 12px">你确定要将已关闭工单重置为进行中吗？</p>
    <div style="display: flex; align-items: center">
      <span style="margin-right: 8px">延长结束时间：</span>
      <el-select v-model="hours"
                 style="width: 120px">
        <el-option v-for="val in hourOptions"
                   :key="val"
                   :label="`${val} 小时`"
                   :value="val">
        </el-option>
      </el-select>
    </div>
    <p style="margin: 8px 0 0; color: #F56C6C; font-size: 12px; line-height: 1.4">
      延长工单时间将最晚不会超过当天23:59:59
    </p>
  </div>
</template>

<script>
const HOUR_OPTIONS = [1, 3, 6, 12]

export default {
  name: 'OrderResetProcessForm',
  data () {
    return {
      hours: 3,
      hourOptions: HOUR_OPTIONS,
    }
  },
  methods: {
    getValue () {
      return this.hours
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/order/components/OrderResetProcessForm.vue